import { FIELD_DESCRIPTION, FIELD_TITLE, FIELDS_INPUT_DECISION_RADIOGROUP } from 'constants/fields';
import DecisionRadioGroup from 'UI/Inputs/DecisionRadioGroup';
import StartEndInputs from 'UI/Inputs/StartEndInputs';
import { FIELDS_START_END_INPUTS } from 'constants/fields';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import './Styles.scss';

class PreviewForm extends Component {

	renderTitle = (field, index) => {
		return <div className="input-label">
			{field.value}
		</div>
	}

	renderDescription = (field, index) => {
		return <div>{field.value}</div>
	}

	renderDecisionRadioGroup = (field, index) => {
		// Use the shared DecisionRadioGroup; disabled for preview and no initial selection
		let labels = ['approved', 'denied'];
		try {
			const parsed = JSON.parse(field.placeholder || '[]');
			if (Array.isArray(parsed)) labels = parsed;
		} catch (e) { }
		return (
			<div className="decision-radio-group">
				<DecisionRadioGroup
					input={{ name: `decision-preview-${index}`, value: '', onChange: () => { } }}
					meta={{}}
					name={`decision-preview-${index}`}
					onChange={() => { }}
					disabled={true}
					labels={labels}
					translate={this.props.translate}
				/>
			</div>
		);
	}

	renderInput = (field, index) => {
		const type = field.type.toLowerCase();

		return <div className={`placeholder-input ${type}`}>
			{this.props.translate(type)}
		</div>
	}

	renderField = (field, index) => {
		if (field.type == FIELD_TITLE) {
			return <div key={'field-' + index} className="form-row field">
				{this.renderTitle(field, index)}
			</div>
		}

		if (field.type === FIELDS_START_END_INPUTS) {
			let parsed = { start: '', end: '', labels: { startLabel: this.props.translate('start') || 'Start', endLabel: this.props.translate('end') || 'End' } };
			try {
				const p = JSON.parse(field.placeholder || '{}');
				if (p) parsed = { ...parsed, ...p };
			} catch (e) { }

			return <div key={index} style={{ marginBottom: '0.85rem' }} className="form-row">
				<StartEndInputs value={{ start: parsed.start, end: parsed.end }} disabled labels={parsed.labels} translate={this.props.translate} />
			</div>
		}

		if (field.type == FIELD_DESCRIPTION) {
			return <div key={'field-' + index} className="form-row field">
				{this.renderDescription(field, index)}
			</div>
		}

		if (field.type === FIELDS_INPUT_DECISION_RADIOGROUP) {
			return <div key={'field-' + index} className="decision-radio-group">
				<div className='form-row field'>
					{this.renderDecisionRadioGroup(field, index)}
				</div>
			</div>
		}

		return <div key={'field-' + index} className="form-row">
			{this.renderInput(field, index)}
		</div>
	}

	render() {
		if (this.props.fields == null) {
			return null;
		}

		let fields = [...this.props.fields];
		fields.sort((a, b) => {
			return a.sortOrder > b.sortOrder ? 1 : -1;
		});

		return (
			<div className="dynamic-form">
				<div className="form form-component">
					{fields.map(this.renderField)}
				</div>
			</div>
		);
	}

}

function mapStateToProps(state) {
	return {
		translate: translate(state.Languages.translations),
	};
}

export default connect(mapStateToProps, null, null, {
	pure: false,
})(PreviewForm);
